import { Component } from 'react';

/** Stops one broken screen from blanking the whole app. */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('Screen crashed:', error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="card">
          <div className="card-head">
            <div className="card-title">This screen stopped working</div>
          </div>
          <div className="alert error">{this.state.error.message}</div>
          <div className="btn-row">
            <button className="btn primary" onClick={() => window.location.reload()}>
              Reload the page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
